var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Boolean',{attrs:{"textOn":"Available","textOff":_vm.picked ? 'Already picked' : _vm.expired ? 'Expired' : 'Unavailable'},model:{value:(_vm.available),callback:function ($$v) {_vm.available=$$v},expression:"available"}})}
var staticRenderFns = []

export { render, staticRenderFns }